module.exports = __webpack_public_path__ + "static/media/cutting-edge.6af3b49b.png";